import { trace, context } from '@opentelemetry/api';

/**
 * Extracts the current trace context (trace ID and span ID) from OpenTelemetry
 *
 * This enables log-trace correlation by adding trace identifiers to log entries.
 * When logs are sent to Splunk, you can search by trace_id to find all logs
 * associated with a specific distributed trace, then jump to Honeycomb for
 * the full trace visualization.
 *
 * @returns Object containing traceId and spanId, or undefined if no active trace
 */
export function getCurrentTraceContext(): { traceId: string; spanId: string } | undefined {
  try {
    const activeSpan = trace.getSpan(context.active());

    if (!activeSpan) {
      return undefined;
    }

    const spanContext = activeSpan.spanContext();

    // Only return if we have a valid, sampled trace
    if (!spanContext || !spanContext.traceId) {
      return undefined;
    }

    return {
      traceId: spanContext.traceId,
      spanId: spanContext.spanId,
    };
  } catch (error) {
    // Fail silently - we don't want trace context extraction to break logging
    console.warn('Failed to extract trace context for logging:', error);
    return undefined;
  }
}

